import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "scenes/navbar";
import apiService from "services/apiService";

const RunPage = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data, error } = await apiService.fetchData("/rent/runs");

        if (!error) {
          setData(data.data);
          setLoading(false);
        } else if (error) {
          setLoading(false);
          console.error("Erreur lors de la récupération des données :", error);
        }
        return data;
      } catch (err) {
        setLoading(false);
        console.error("Erreur dans fetchData :", err);
        return null;
      }
    };
    fetchData();
  }, []);

  const handleRowClick = (item) => {
    navigate(`/run/${item._id}`);
  };

  return (
    <>
      <Navbar />
      <Box
        sx={{
          p: 2,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography variant="h1" fontWeight={700}>
          Historique des Exécutions
        </Typography>
        <Box sx={{ flex: 1, minHeight: 0, mt: 1 }}>
          <TableContainer
            component={Paper}
            sx={{
              height: "100%",
              maxHeight: "500px",
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      fontWeight: "700",
                      fontSize: "1.1rem",
                    }}
                  >
                    Date
                  </TableCell>
                  <TableCell
                    sx={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      fontWeight: "700",
                      fontSize: "1.1rem",
                    }}
                  >
                    Ville
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={3}>Loading...</TableCell>
                  </TableRow>
                ) : (
                  data.map((item) => (
                    <TableRow
                      key={item.runDate}
                      hover
                      sx={{ cursor: "pointer" }}
                      onClick={() => handleRowClick(item)}
                    >
                      <TableCell sx={{ fontWeight: "500" }}>
                        {new Date(item.runDate).toLocaleString("fr-FR", {
                          dateStyle: "short",
                          timeStyle: "short",
                        })}
                      </TableCell>
                      <TableCell sx={{ fontWeight: "500" }}>
                        {item.ville}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </>
  );
};

export default RunPage;
